"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditAudienceRequestToJSON = exports.EditAudienceRequestFromJSONTyped = exports.EditAudienceRequestFromJSON = void 0;
var EditCustomAudienceRequest_1 = require("./EditCustomAudienceRequest");
var EditLookalikeAudienceRequest_1 = require("./EditLookalikeAudienceRequest");
function EditAudienceRequestFromJSON(json) {
    return EditAudienceRequestFromJSONTyped(json, false);
}
exports.EditAudienceRequestFromJSON = EditAudienceRequestFromJSON;
function EditAudienceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['audience_type']) {
        case 'CUSTOM':
            return __assign(__assign({}, (0, EditCustomAudienceRequest_1.EditCustomAudienceRequestFromJSONTyped)(json, true)), { audienceType: 'CUSTOM' });
        case 'LOOKALIKE':
            return __assign(__assign({}, (0, EditLookalikeAudienceRequest_1.EditLookalikeAudienceRequestFromJSONTyped)(json, true)), { audienceType: 'LOOKALIKE' });
        default:
            throw new Error("No variant of EditAudienceRequest exists with 'audienceType=".concat(json['audienceType'], "'"));
    }
}
exports.EditAudienceRequestFromJSONTyped = EditAudienceRequestFromJSONTyped;
function EditAudienceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['audienceType']) {
        case 'CUSTOM':
            return (0, EditCustomAudienceRequest_1.EditCustomAudienceRequestToJSON)(value);
        case 'LOOKALIKE':
            return (0, EditLookalikeAudienceRequest_1.EditLookalikeAudienceRequestToJSON)(value);
        default:
            throw new Error("No variant of EditAudienceRequest exists with 'audienceType=".concat(value['audienceType'], "'"));
    }
}
exports.EditAudienceRequestToJSON = EditAudienceRequestToJSON;
